import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Fit call',
    description:
      '30 minutes, free. We check whether AI is the right tool for your problem. If it is not, we say so.',
  },
  {
    number: '02',
    title: 'AI Audit',
    description:
      '5 days, EUR 1,500. We pick the best workflow to start with, write the high-level design and the statement of work: what we build, the scope and the price. The fee comes off the build.',
  },
  {
    number: '03',
    title: 'Build',
    description:
      'MVP in 6 weeks, fixed price. We start with the low-level design, then build it on your data inside your own cloud.',
  },
  {
    number: '04',
    title: 'Run',
    description:
      'Monthly, fixed price. We run it, watch it and improve it every month. Keep everything and stop any time.',
  },
];

const guarantees = [
  'Fixed price agreed before work starts',
  'You own the code, cloud, data and models',
  'Stop at any step and keep everything',
];

const Purpose: React.FC = () => {
  return (
    <section id="how-it-works" className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-2xl mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-black leading-[1.05] tracking-[-0.02em] mb-5">
            How we work. Four steps, no surprises.
          </h2>
          <p className="text-lg text-neutral-600 leading-relaxed">
            From first conversation to production. Here is what working with us looks like.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-14">
          {steps.map((step) => (
            <div key={step.number}>
              <p className="text-xs font-semibold text-neutral-400 tracking-widest mb-3">
                Step {step.number}
              </p>
              <h3 className="text-xl font-semibold text-black mb-3 tracking-tight">{step.title}</h3>
              <p className="text-neutral-600 leading-relaxed text-[0.95rem]">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="border-t border-neutral-200 pt-8 flex flex-col sm:flex-row gap-6 sm:gap-10">
          {guarantees.map((g) => (
            <div key={g} className="flex items-center gap-2.5">
              <svg className="w-4 h-4 text-neutral-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span className="text-sm text-neutral-600">{g}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Purpose;
